export const ResponsesRoutes = {
    Index: '/responses',
    Invited: '/responses/invited',
    Mutual: '/responses/mutual',
    Archived: '/responses/archived',
};
